'use client';

import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';

import { cn } from '#/lib/utils';
import { MenuItems } from '#/data/menu';
import { ROUTES } from '#/data/constants';
import { UpdateNewBadge } from './update-new-badge';
import { TryMenu } from './try-menu';
import { trackEvent } from '#/lib/analytics';
interface MainNavProps {
  className: string;
  permissions: string[];
  system?: boolean;
  latestUpdateAt?: string | null;
}

export function MainNav({
  className,
  permissions,
  system,
  latestUpdateAt
}: MainNavProps) {
  const pathname = usePathname();
  const params = useParams();
  const routes = MenuItems(params, pathname || '');

  return (
    <nav
      className={cn(
        'flex items-center space-x-2 sm:space-x-3 md:space-x-4 lg:space-x-6 flex-wrap gap-1 sm:gap-2',
        className
      )}
    >
      {routes
        .filter(
          (r) =>
            (system && !r.hide) ||
            r.default === true ||
            r.permissions?.filter((p) => permissions.includes(p.toString()))
              .length
        )
        .map((route) => {
          // 대표 진입점은 링크 하나가 아니라 하위 도구를 펼치는 드롭다운으로 낸다.
          if (route.dropdown && route.children?.length) {
            return (
              <TryMenu
                key={route.href}
                route={route}
                pathname={pathname ?? ''}
              />
            );
          }

          const isLink =
            system || route.default
              ? route.href
              : route.children?.find((c) =>
                  c.permissions.find((p) => permissions.includes(p))
                )?.href;
          if (isLink) {
            return (
              <Link
                key={route.href}
                href={isLink}
                onClick={() =>
                  // GA4: 헤더에서 다른 기능으로 넘어간 내부 링크 이동.
                  trackEvent('click_other_menu', {
                    location: 'header_nav',
                    from: pathname ?? '',
                    to: isLink,
                    label: route.label
                  })
                }
                className={cn(
                  'text-sm font-medium transition-all duration-200 hover:text-[#104573] relative',
                  route.active
                    ? 'text-[#104573] dark:text-[#60a3d9] after:absolute after:bottom-[-4px] after:left-0 after:right-0 after:h-[2px] after:bg-[#104573] after:dark:bg-[#60a3d9] after:rounded-full'
                    : 'text-muted-foreground hover:text-[#104573]'
                )}
              >
                {route.label}
                {route.href === ROUTES.UPDATE_LOGS && latestUpdateAt && (
                  <UpdateNewBadge latestDate={latestUpdateAt} />
                )}
              </Link>
            );
          }
        })}
    </nav>
  );
}
